import React, { ReactNode, useState } from 'react'
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io'

const Section = ({
  title,
  children,
  canClose = false,
}: {
  title: string
  children: ReactNode
  canClose?: boolean
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(true)

  return (
    <section className="py-4 border-t-gray-200 border-t-2 px-4">
      <span className="flex justify-between items-center ">
        <h2 className="text-left font-bold text-18 text-bidfta-blue-dark">
          {title}
        </h2>

        {canClose ? (
          <button onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <IoIosArrowUp size={24} /> : <IoIosArrowDown size={24} />}
          </button>
        ) : (
          <></>
        )}
      </span>
      {isOpen ? <div className="my-4">{children}</div> : <></>}
    </section>
  )
}

export default Section
